module.exports = __webpack_public_path__ + "static/media/phones_promo_image.fc22237d.webp";